import { Router } from "@angular/router";

/**
 * Layouts redirect to their default tab while they are being created. If the router is
 * already navigating to that URL, navigating again cancels the in-flight navigation, so no
 * NavigationEnd fires and routerLinkActive never marks the tab active (Angular 18+).
 */
export function navigateToTab(router: Router, url: string) {
  const pending = router.currentNavigation();
  const target = pending?.finalUrl ?? pending?.extractedUrl;
  if (target && router.serializeUrl(target) === router.serializeUrl(router.parseUrl(url))) {
    return;
  }
  router.navigateByUrl(url);
}
